import { makeStyles } from "@material-ui/core/styles";
import { Button, ListItem, ListItemAvatar } from "@mui/material";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { Link } from "react-router-dom";
import LoadingGrid from "components/Loading/LoadingFull";
import MeuPlanoAtual from "components/Uteis/MeuPlanoAtual";
import MySnackbarErro from "components/Uteis/MySnackbarErro";
import React, { useEffect, useState } from "react";
import api from "services/api.js";
import { serverApi } from "services/constante.js";
import { CardPedido } from "components/Card/CardPedido";
import Table from "@material-ui/core/Table";
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        //maxWidth: 360,
        backgroundColor: 'trnsparent',
    },
    titulo: {
        fontSize: '14px',
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 500
    },
    inline: {
        display: 'inline',
        color: '#787878',
        fontFamily: 'Montserrat, sans-serif',
    },
    iconColor: {
        color: "#FFF"
    },
    boxPontosDK: {
        position: 'absolute',
        bottom: '15px',
        left: '2px',
        color: '#737495'
    },
    boxPontosMB: {
        position: 'absolute',
        bottom: '0px',
        left: '5px',
        top: '30px',
        color: '#737495'
    },
    itemList: {
        display: "flex",
        flexDirection: 'column',
        position: 'relative',
        backgroundColor: 'white',
        marginBottom: '15px',
        borderRadius: '10px',
        border: "1px solid #e2e2e2",
        flex: 1,
        padding: "10px 15px 15px 15px !important",
        marginRight: '20px',
        marginLeft: '20px',
        minWidth: '340px',
        cursor: 'pointer',
        textDecoration: 'none',
    },
    statusDisplay: {
        width: 10,
        height: 10,
        display: 'inline-block',
        // borderRadius: '5px',
        marginRight: '5px'
    },
    boxStatus: {
        marginRight: '7px',
        fontFamily: 'Montserrat, sans-serif',
    },
    textStatusDisplay: {
        color: '#787878'
    },
    boxConteudo: {
        paddingLeft: '5px'
    },
    headerDivider: {
        borderLeft: '1px solid #e2e2e2',
        borderRight: '1px solid #e2e2e2',
        height: '77px',
        position: 'absolute',
        left: '65px',
        top: '35px'
    }
}));


export default function HistoricoPedidos(props) {
    const [loadingGrid, setLoadingGrid] = useState(true);
    const [pedidos, setPedidos] = useState([]);
    const [isErro, setIsErro] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const classes = useStyles();

    const carregarDados = async () => {
        try {
            setIsErro(false);
            setLoadingGrid(true);

            const userResponse = await api.get(serverApi.url + serverApi.versao + '/Usuario/Perfil');
            const user = userResponse.data;
            const userGuid = user.Guid;

            const formData = new FormData();
            formData.append("function", "get_vendas");
            formData.append("guid", userGuid);

            const res = await api.post(serverApi.urlPHP + '/venda.php', formData);

            // console.log("novos pedidos:", res.data);
            setPedidos(res.data?.reverse());
        } catch (e) {
            console.error(e);
            setErrorMessage("Não foi possível consultar seus pedidos no momento.");
            setIsErro(true);
        } finally {
            setLoadingGrid(false);
        }
    };

    const formatarValor = (pedido) => {
        const value = (pedido.ValorTotalDesconto != null) ? pedido.ValorTotalDesconto : pedido.ValorTotal;
        const numericValue = Number.parseFloat(value);
        return numericValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
        });
    }

    const formatarData = (isoDateTime) => {
        console.log(isoDateTime);
        if (isoDateTime == null || !isoDateTime.includes(" ")) {
            return isoDateTime;
        }
        const [isoDate, _time] = isoDateTime.split(" ");
        const [year, month, day] = isoDate.split("-");
        return [day, month, year].join("/");
    };

    const getProdutosTexto = (produtos) => {
        return produtos.map(produto => `• ${produto}`).join("\n");
    }

    useEffect(() => {
        carregarDados();
    }, []);

    return (
        <div>
            <LoadingGrid display={loadingGrid} />
            <div
                style={{
                    paddingTop: "2.5%"
                }}
            >
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Id</TableCell>
                                <TableCell align="center">Cadastrado em</TableCell>
                                <TableCell align="center">Valor</TableCell>
                                <TableCell align="center">Status</TableCell>
                                <TableCell align="center">Produtos</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {pedidos.map((pedido, i) => (
                                <TableRow
                                    key={i}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell align="center">
                                        {pedido.Id}
                                    </TableCell>
                                    <TableCell align="center">
                                        {formatarData(pedido.DataVenda)}
                                    </TableCell>
                                    <TableCell align="center">
                                        {formatarValor(pedido)}
                                    </TableCell>
                                    <TableCell align="center">
                                        {pedido.CodigoStatusVendaDescricao}
                                    </TableCell>
                                    <TableCell align="center">
                                        {pedido.Produtos?.join(", ")}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <MySnackbarErro IsErro={isErro} Mensagem={errorMessage} />
        </div>
    );
}